/* Borealis header behaviour: hide on scroll down / show on scroll up, glass state, mega menus (1..n), mobile drawer. */
(function () {
  function init(wrap) {
    if (!wrap || wrap.__bhd) return;
    wrap.__bhd = true;
    var header = wrap.querySelector('.bhd');
    var scrim = wrap.querySelector('.bhd__scrim');
    var drawer = wrap.querySelector('.bhd__drawer');
    var burger = wrap.querySelector('.bhd__burger');
    var closeBtn = wrap.querySelector('.bhd__close');
    var delay = parseInt(wrap.getAttribute('data-hover-delay') || '120', 10);
    var mode = wrap.getAttribute('data-behavior') || 'scroll-up';
    var openIdx = null, drawerOpen = false, openT, closeT, lastY = window.scrollY, ticking = false;
    var triggers = {}, panels = {};
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-bhd-mega]'), function (t) { triggers[t.getAttribute('data-bhd-mega')] = t; });
    Array.prototype.forEach.call(wrap.querySelectorAll('.bhd__mega'), function (p) { panels[p.getAttribute('data-group')] = p; });

    function openMega(idx) {
      if (openIdx === idx || !panels[idx]) return;
      if (openIdx !== null) hideOnly(openIdx);
      openIdx = idx;
      panels[idx].classList.add('is-open');
      header.classList.add('is-mega');
      header.classList.remove('is-hidden');
      scrim.classList.add('is-on');
      if (triggers[idx]) triggers[idx].setAttribute('aria-expanded', 'true');
    }
    function hideOnly(idx) {
      if (panels[idx]) panels[idx].classList.remove('is-open');
      if (triggers[idx]) triggers[idx].setAttribute('aria-expanded', 'false');
    }
    function closeMega() {
      if (openIdx === null) return;
      hideOnly(openIdx);
      openIdx = null;
      header.classList.remove('is-mega');
      scrim.classList.remove('is-on');
    }
    Object.keys(triggers).forEach(function (idx) {
      var t = triggers[idx], p = panels[idx];
      if (!p) return;
      t.addEventListener('mouseenter', function () {
        clearTimeout(closeT);
        openT = setTimeout(function () { openMega(idx); }, openIdx !== null ? 0 : delay);
      });
      t.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(closeMega, 260); });
      p.addEventListener('mouseenter', function () { clearTimeout(closeT); });
      p.addEventListener('mouseleave', function () { closeT = setTimeout(closeMega, 260); });
      t.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && openIdx !== idx) { e.preventDefault(); openMega(idx); }
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openMega(idx); var a = p.querySelector('a'); if (a) a.focus(); }
      });
    });
    Array.prototype.forEach.call(wrap.querySelectorAll('.bhd__nav a.bhd__link:not([data-bhd-mega])'), function (a) {
      a.addEventListener('mouseenter', function () { clearTimeout(openT); closeMega(); });
    });
    scrim.addEventListener('click', closeMega);

    function setDrawer(open) {
      if (!drawer) return;
      drawerOpen = open;
      drawer.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('bhd-lock', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open && closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
      if (!open && burger) burger.focus();
    }
    if (burger) burger.addEventListener('click', function () { setDrawer(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-bhd-acc]'), function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentNode;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (openIdx !== null) { var k = openIdx; closeMega(); if (triggers[k]) triggers[k].focus(); }
        if (drawerOpen) setDrawer(false);
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990 && drawerOpen) setDrawer(false); });

    function onScroll() {
      var y = window.scrollY, dy = y - lastY;
      header.classList.toggle('is-scrolled', y > 8);
      if (mode === 'scroll-up' && openIdx === null && !drawerOpen) {
        if (dy > 6 && y > 140) header.classList.add('is-hidden');
        else if (dy < -4 || y < 10) header.classList.remove('is-hidden');
      }
      if (Math.abs(dy) > 2) lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();

    var counts = wrap.querySelectorAll('.bhd__count');
    function setCount(n) {
      Array.prototype.forEach.call(counts, function (c) { c.textContent = n; c.hidden = !(n > 0); });
    }
    function refreshCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); })
        .catch(function () {});
    }
    ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart:added'].forEach(function (n) {
      document.addEventListener(n, refreshCart);
    });
    window.addEventListener('pageshow', refreshCart);
  }
  function boot() { init(document.querySelector('.bhd-wrap')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();